import {MULTISELECT_ID_AND_PERMS, MULTISELECT_ID_ONLY} from "@/components/forms/FormsActions";

const DELAY = 400;

export default class DataStream {
    /**
     * @param initialStreamResult {StreamResult}
     * @param streamEngine {StreamingEngine}
     * @param ancestor {DataStream}
     */
    constructor(initialStreamResult, streamEngine, ancestor) {
        this.defaultSelectAll = false;
        this.age = 0;

        this.initialStreamResult = initialStreamResult;
        this.streamEngine = streamEngine;

        this.loadedRows = new Map();
        this.PENDING = {__pending__: true, __dataStream__: this};

        this.pendingRows = new Map();
        //this.renderers = new Set();
        this.metaRenderers = new Set();

        this.lastScroll = null;
        this.refreshTimer = null;
        this.selectecRows = new Set();

        if (this.initialStreamResult.records == null) {
            this.initialStreamResult.records = this.initialStreamResult.viewRows;
        }

        this.streamEngine.dataGrid.postProcessStreamRecords(this.initialStreamResult.records)

        for (let i in this.initialStreamResult.records) {
            this.initialStreamResult.records[i].__dataStream__ = this;
            this.loadedRows.set(parseInt(i) + this.initialStreamResult.offset, this.initialStreamResult.records[i]);
        }

        if (ancestor) {
            // for(let k in ancestor.loadedRows){
            //     let row = ancestor.loadedRows.get(k);
            //     if(row?.__meta__?.selected){
            //
            //     }
            // }
            this.metaRenderers = ancestor.metaRenderers;
            ancestor.cleanReferences();
        }
    }

    cleanReferences() {
        this.defaultSelectAll = false;
        this.initialStreamResult = null;
        this.streamEngine = null;

        this.loadedRows = new Map();
        this.pendingRows = new Map();
        this.renderers = null
        this.metaRenderers = new Set();

        this.lastScroll = null;
        this.refreshTimer = null;
    }

    getExcludedFromSelectionIds() {
        let res = [];
        if (!this.defaultSelectAll) {
            return res;
        }

        for (let [k, item] of this.loadedRows) {
            if (item?.__meta__ && !item?.__meta__?.selected) {
                res.push(item.__full_id__ ?? item.id);
            }
        }
        return res;
    }

    getExcludedFromSelectionWithNullIds(streamingEngine, uniqueColumn) {
        streamingEngine.excludedUniqueIdentityForNullIds = [];
        streamingEngine.excludedIds = [];
        for (let [k, item] of this.loadedRows) {
            if (item?.__meta__ && !item?.__meta__?.selected) {
                if (item.id) {
                    streamingEngine.excludedIds.push(item.id);
                } else {
                    streamingEngine.excludedUniqueIdentityForNullIds.push(item[uniqueColumn]);
                }
            }
        }
    }

    getSelectedItems() {
        let items = new Map();
        let indices = [];
        let unselectedItems = new Map();
        let unselectedIndices = [];
        let countSelected = 0;
        let countUnselected = 0;
        for (let [k, item] of this.loadedRows) {
            if (item?.__meta__?.selected) {
                items.set(countSelected, item);
                indices.push(k);
                countSelected++;
            } else {
                unselectedItems.set(countUnselected, item);
                unselectedIndices.push(k);
                countUnselected++;
            }
        }

        let totalSelected = countSelected;
        if (this.defaultSelectAll) {
            totalSelected = this.initialStreamResult.totals - countUnselected;
        }
        let fields = {
            items, indices, unselectedItems, unselectedIndices, totalSelected, countSelected
        }

        let vItem = {
            [Symbol.iterator]() {
                let index = 0;
                return {
                    next() {
                        if (index < fields.totalSelected) {
                            let val;
                            if (fields.items.has(index)) {
                                val = fields.items.get(index);
                            } else {
                                val = this.PENDING;
                            }
                            index++;
                            return {value: val, done: false};
                        } else return {done: true};
                    }
                };
            }
        };
        const handler = {
            get: (target, index) => {
                if (index === 'length') {
                    return fields.totalSelected;
                } else if (index === "dataStream") {
                    return this;
                } else if (index === "map") {
                    return (callback) => {
                        let res = [];
                        for(let i=0; i< fields.totalSelected; i++){
                            let el = this.PENDING;
                            if (fields.items.has(i)) {
                                el = fields.items.get(i);
                            }
                            res.push(callback(el));
                        }
                        return res;
                    }
                } else if (index === "knownSelected") {
                    return fields.items;
                } else if (index === "virtual") {
                    return fields.totalSelected = fields.countSelected;
                } else if (index === "materialize") {
                    return async (format) => {
                        this.materializeSelection(fields, format);
                    };
                }
                if (typeof index == "string") {
                    let i = parseInt(index);
                    if (!isNaN(i)) {
                        if (fields.items.has(i)) {
                            return fields.items.get(i);
                        }
                        return this.PENDING;
                    }
                }
                return vItem[index];
            }
        };
        return new Proxy(vItem, handler);
    }

    findItemById(instance){
        if(instance.id) {
            for (const [k, v] of this.loadedRows) {
                if (instance.id == v.id){
                    return k;
                }
            }
        }

        return null;
    }
    findItems(instance, comparator){
        let res = [];
        for (const [k, v] of this.loadedRows) {
            if (comparator(instance, v)) {
                res.push(k);
            }
        }
        return res;
    }

    add(results){
        // console.log(results);
        if(results.locatedOffset < 0 || results.records.length < 1 || this.initialStreamResult.totals + 1 !== results.totals){
            this.initialStreamResult.totals = results.totals;
            this.reset();
            return false;
        }
        let shiftedMap = new Map();
        for(const [key, value] of this.loadedRows) {
            const intKey = parseInt(key);
            if(intKey < results.locatedOffset){
                shiftedMap.set(intKey, value);
                continue;
            }
            if(intKey >= results.locatedOffset){
                shiftedMap.set(intKey + 1, value);
            }
        }
        shiftedMap.set(results.locatedOffset, results.records[0]);
        this.loadedRows = shiftedMap;
        this.initialStreamResult.totals++;
        return true;
    }

    delete(itemId){
        let deletedIndex = -1;
        for(const [key, value] of this.loadedRows) {
            if(value?.id === itemId){
                deletedIndex = parseInt(key);
                break;
            }
        }
        if(deletedIndex === -1){
            return false;
        }
        let shiftedMap = new Map();
        // czy najpierw refresh się nie stał a później to, bo wtedy mógłby byc błąd
        for(const [key, value] of this.loadedRows) {
            const intKey = parseInt(key);
            if(intKey < deletedIndex){
                shiftedMap.set(key, value);
                continue;
            }
            if(intKey > deletedIndex){
                shiftedMap.set(intKey - 1, value);
            }
        }
        this.loadedRows = shiftedMap;
        this.initialStreamResult.totals--;

        return true;
    }

    invalidateItemAtOffset(offset){
        if(this.loadedRows.has(offset)){
            this.loadedRows.delete(offset);
        }
    }

    updateRowRendererWhenReady(itemIndex, rel, data, rowsEls){
    }
    async materializeSelection(fields, format=MULTISELECT_ID_ONLY) {
        let {/** @type{Map}*/
            items,
            indices,
            unselectedItems,
            unselectedIndices,
            totalSelected,
            countSelected
        } = fields;
        if (!this.defaultSelectAll) {
            return;
        }
        if (items.size === totalSelected) {
            return;
        }

        if(totalSelected > 300){
            DialogManager.openPendingDialog($tr('loadingData','Loading data'), $tr('loadingSelectedRecords','Loading selected records'));
        }
        try {
            let res = await this.streamEngine.materialize(format)
            // public @IdInOrganization List<Long> ids;
            // public List<IdWithPerms> idsWithPerms;
            // public List<BusinessRecord> records;

            if (format === MULTISELECT_ID_ONLY) {
                for (let i = 0; i < res.ids.length; i++) {
                    items.set(i, {id: res.ids[i]});
                }
                return
            }
            if (format === MULTISELECT_ID_AND_PERMS) {
                for (let i = 0; i < res.ids.length; i++) {
                    const entry = res.ids[i];
                    items.set(i, {
                        id: entry.id, __supplement__: {
                            canDelete: entry.canDelete,
                            editable: entry.editable,
                        }
                    });
                }
                return
            }
            for (let i = 0; i < res.records.length; i++) {
                items.set(i, res.records[i]);
            }
        } finally {
            if(totalSelected > 300){
                DialogManager.closePendingDialog();
            }
        }
    }

    selectAll() {
        this.defaultSelectAll = true;
        for (let [k, item] of this.loadedRows) {
            if (item?.__meta__) {
                item.__meta__.selected = true;
            } else {
                item.__meta__ = {selected: true}
            }
        }
        if (this.streamEngine.isV3()) {
            this.streamEngine.getBaseGridV3().checkDataInCells();
        } else {
            this.metaRenderers.forEach(mr => mr.refreshSelection());
        }
    }

    unselectAll() {
        this.defaultSelectAll = false;
        for (let [k, item] of this.loadedRows) {
            if (item?.__meta__) {
                item.__meta__.selected = false;
            } else {
                item.__meta__ = {selected: false}
            }
        }
        if (this.streamEngine.isV3()) {
            this.streamEngine.getBaseGridV3().checkDataInCells();
        } else {
            this.metaRenderers.forEach(mr => mr.refreshSelection());
        }
    }

    clearSelection() {
        this.defaultSelectAll = false;
    }

    getResultArray() {
        let vItem = {};
        const handler = {
            get: (target, index) => {
                if (index === 'length') {
                    return this.initialStreamResult?.totals ?? 0;
                } else if (index === "dataStream") {
                    return this;
                }
                if (typeof index == "string") {
                    let i = parseInt(index);
                    if (!isNaN(i)) {
                        if (this.loadedRows?.has(i)) {
                            return this.loadedRows.get(i);
                        }
                        return this.PENDING;
                    }
                }
                return vItem[index];
            }
        };
        return new Proxy(vItem, handler);
    }

    registerMetaRenderer(r) {
        this.metaRenderers.add(r);
    }

    requestRow(rowIndex, rowInstanceId, loadingCellRenderer) {
        this.pendingRows.set(rowInstanceId, rowIndex);
        this.lastScroll = Date.now();
        if (!this.refreshTimer) {
            this.refreshTimer = setTimeout(() => this.processLoadRequest(), DELAY);
        }
    }

    processLoadRequest() {
        let delta = Date.now() - this.lastScroll;
        if (delta < DELAY - 10) {
            const newDelay = DELAY - delta + 10;
            Log.debug(`Wait ${newDelay}ms more`);
            this.refreshTimer = setTimeout(() => this.processLoadRequest(), newDelay);
            return;
        }

        this.refreshTimer = null;
        this.loadChunk();
        this.pendingRows = new Map();
    }

    /**
     * @param result {StreamResult}
     */
    async processChunk(result) {
        if (result.records == null) {
            result.records = result.viewRows;
        }
        await this.streamEngine.dataGrid.postProcessStreamRecords(result.records);

        for (let i in result.records) {
            const idx = parseInt(i) + result.offset;
            result.records[i].__dataStream__ = this;

            let item = result.records[i];
            if (item?.__meta__) {
                item.__meta__.selected = this.defaultSelectAll;
            } else {
                item.__meta__ = {selected: this.defaultSelectAll}
            }
            if(this.loadedRows.size > 500){
                this.gc(result.offset);
            }
            this.loadedRows.set(idx, result.records[i]);
        }
        this.initialStreamResult = result;
    }

    gc(windowLocation){
        let oldRows =  this.loadedRows;
        this.loadedRows = new Map();

        for (let [k, item] of oldRows){
            if (item?.__meta__?.selected) {
                this.loadedRows.set(k, oldRows.get(k));
            }
        }


        let i = windowLocation - 100;
        if(i<0){
            i = 0;
        }
        for(;i < windowLocation + 100; i++){
            if(oldRows.has(i)){
                this.loadedRows.set(i, oldRows.get(i));
            }
        }
        console.log("Streaming GC done");
    }
     reset() {
        this.loadedRows = new Map();
        this.initialStreamResult.totals = 0;
        this.initialStreamResult.offset = 0;
    }

    async reorder(result) {
        if (result.records == null) {
            result.records = result.viewRows;
        }

        this.loadedRows = new Map();
        await this.streamEngine.dataGrid.postProcessStreamRecords(result.records);

        for (let i in result.records) {
            const idx = parseInt(i) + result.offset;
            result.records[i].__dataStream__ = this;
            let item = result.records[i];
            if (item?.__meta__) {
                item.__meta__.selected = this.defaultSelectAll;
            } else {
                item.__meta__ = {selected: this.defaultSelectAll}
            }

            this.loadedRows.set(idx, result.records[i]);
        }
        this.initialStreamResult = result;
        this.streamEngine.dataGrid.$refs.baseGrid?.focusOnOffset(result.locatedOffset);
        //this.renderers.forEach(renderer => renderer.refresh());
    }

    loadChunk() {
        let min = -1;
        let max = -1;
        if(!this.pendingRows){
            return;
        }
        for (let [rowInstanceId, rowIndex] of this.pendingRows) {
            if(this.loadedRows.has(parseInt(rowIndex))){
                continue;
            }
            if (rowIndex < min || min === -1) {
                min = rowIndex;
            }
            if (rowIndex > max) {
                max = rowIndex;
            }
        }
        if (max === -1) {
            return;
        }

        min -= 5;
        max += 5;
        if(this.initialStreamResult != null && max >  this.initialStreamResult.totals-1){
            max =  this.initialStreamResult.totals -1;
        }

        if (min < 0) {
            min = 0;
        }

        let minRowIndex = min;
        while (minRowIndex <= max) {
            if (!this.loadedRows.has(minRowIndex)) {
                break;
            }
            minRowIndex++;
        }
        if (minRowIndex > max) {
            return;
        }

        let maxRowIndex = max;
        while (maxRowIndex > min) {
            if (!this.loadedRows.has(minRowIndex)) {
                break;
            }
            maxRowIndex--;
        }

        let offset = minRowIndex;
        let windowSize = maxRowIndex - minRowIndex + 1;
        if(windowSize === 0){
            return;
        }
        if(this.streamEngine) {
            const baseGrid = this.streamEngine.dataGrid.$refs?.baseGrid;
            if (baseGrid) {
                if (windowSize > 1.5 * baseGrid.windowSize()) {
                    offset = baseGrid.firstVisibleIndex() - 3;
                    offset = offset < 0 ? 0 : offset;
                    windowSize = baseGrid.windowSize() + 6;
                }
            }
            this.streamEngine.requestChunk(offset, windowSize);
        }
    }
}